import { render, staticRenderFns } from "./purchaseOutList.vue?vue&type=template&id=6fabf89e"
import script from "./purchaseOutList.vue?vue&type=script&lang=js"
export * from "./purchaseOutList.vue?vue&type=script&lang=js"
import style0 from "./purchaseOutList.vue?vue&type=style&index=0&id=6fabf89e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports